import { Drawer, DialogElement, extractSectionId, formatMoney } from "//www.paulfredrick.com/cdn/shop/t/1079/assets/theme.js?v=174315472123713571861792764484";

// ============================================================
// js/common/cart/fetch-cart.js
// ============================================================
var createCartPromise = () => {
  return new Promise(async (resolve) => {
    resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
  });
};
var fetchCart = createCartPromise();
document.addEventListener("cart:change", (event) => {
  fetchCart = event.detail["cart"];
});
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    fetchCart = createCartPromise();
  }
});

// ============================================================
// js/common/cart/cart-count.js
// ============================================================
import { animate as animate3 } from "//www.paulfredrick.com/cdn/shop/t/1079/assets/vendor.min.js?v=52426788336887041471792764329";

var CartCount = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(
      document
        .createRange()
        .createContextualFragment("<span><slot></slot></span>")
    );
  }
  connectedCallback() {
    this._abortController = new AbortController();
    document.addEventListener(
      "cart:change",
      (event) => (this.itemCount = event.detail["cart"]["item_count"]),
      { signal: this._abortController.signal }
    );
    document.addEventListener(
      "cart:refresh",
      this._updateFromServer.bind(this),
      { signal: this._abortController.signal }
    );
    window.addEventListener("pageshow", this._updateFromServer.bind(this));
    new LineQuantity()
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  async _updateFromServer() {
    this.itemCount = (await fetchCart)["item_count"];
  }
  get itemCount() {
    return parseInt(this.innerText);
  }
  set itemCount(count) {
    if (this.itemCount === count) {
      return;
    }
    if (count === 0) {
      animate3(this, { opacity: 0 }, { duration: 0.1 });
      if (this.closest(".cart-drawer__inner")) {
        this.innerHTML = `(<span class="cart-count-number">${count}</span>)`
      } else {
        this.innerHTML = `<span class="cart-count-number">${count}</span>`
      }
    } else if (this.itemCount === 0) {
      animate3(this, { opacity: 1 }, { duration: 0.1 });
      if (this.closest(".cart-drawer__inner")) {
        this.innerHTML = `(<span class="cart-count-number">${count}</span>)`
      } else {
        this.innerHTML = `<span class="cart-count-number">${count}</span>`
      }
    } else {
      (async () => {
        await animate3(
          this.shadowRoot.firstElementChild,
          { transform: ["translateY(-50%)"], opacity: 0 },
          { duration: 0.25, easing: [1, 0, 0, 1] }
        ).finished;
        if (this.closest(".cart-drawer__inner")) {
          this.innerHTML = `(<span class="cart-count-number">${count}</span>)`
        } else {
          this.innerHTML = `<span class="cart-count-number">${count}</span>`
        }
        animate3(
          this.shadowRoot.firstElementChild,
          { transform: ["translateY(50%)", "translateY(0)"], opacity: 1 },
          { duration: 0.25, easing: [1, 0, 0, 1] }
        );
      })();
    }
  }
};
if (!window.customElements.get("cart-count")) {
  window.customElements.define("cart-count", CartCount);
}

// ============================================================
// js/common/cart/cart-drawer.js
// ============================================================
import { animate as animate4 } from "//www.paulfredrick.com/cdn/shop/t/1079/assets/vendor.min.js?v=52426788336887041471792764329";

var CartDrawer = class extends Drawer {
  constructor() {
    super();
    this._onPrepareBundledSectionsListener =
      this._onPrepareBundledSections.bind(this);
    this._onCartChangedListener = this._onCartChanged.bind(this);
    this._onCartRefreshListener = this._onCartRefresh.bind(this);
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
    window.addEventListener("pageshow", this._onPageShow.bind(this));
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(
      "cart:prepare-bundled-sections",
      this._onPrepareBundledSectionsListener
    );
    document.addEventListener("cart:change", this._onCartChangedListener);
    document.addEventListener("cart:refresh", this._onCartRefreshListener);
    document.addEventListener("variant:add", this._onVariantAddedListener);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      "cart:prepare-bundled-sections",
      this._onPrepareBundledSectionsListener
    );
    document.removeEventListener("cart:change", this._onCartChangedListener);
    document.removeEventListener("cart:refresh", this._onCartRefreshListener);
    document.removeEventListener("variant:add", this._onVariantAddedListener);
  }
  get shouldAppendToBody() {
    return false;
  }
  get openFrom() {
    return "right";
  }
  _onPrepareBundledSections(event) {
    event.detail.sections.push(extractSectionId(this));
  }
  /**
   * Update the cart drawer content when cart content changes.
   */
  async _onCartChanged(event) {
    const updatedDrawerContent = new DOMParser().parseFromString(
      event.detail.cart["sections"][extractSectionId(this)],
      "text/html"
    );
    if (event.detail.cart["item_count"] > 0) {
      const currentInner = this.querySelector(".cart-drawer__inner"),
        updatedInner = updatedDrawerContent.querySelector(
          ".cart-drawer__inner"
        );
      if (!currentInner) {
        this.replaceChildren(
          document
            .createRange()
            .createContextualFragment(
              updatedDrawerContent.querySelector(".cart-drawer").innerHTML
            )
        );
      } else {
        setTimeout(
          () => {
            currentInner.innerHTML = updatedInner.innerHTML;
          },
          event.detail.baseEvent === "variant:add" ? 0 : 1250
        );
        this.querySelector('[slot="footer"]').replaceChildren(
          ...updatedDrawerContent.querySelector('[slot="footer"]').childNodes
        );
      }
    } else {
      await animate4(this.children, { opacity: 0 }, { duration: 0.15 })
        .finished;
      this.replaceChildren(
        ...updatedDrawerContent.querySelector(".cart-drawer").childNodes
      );
      animate4(
        this.querySelector(".empty-state"),
        { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] },
        { duration: 0.15 }
      );
    }
  }
  /**
   * Handle the case when the page is served from BF cache
   */
  _onPageShow(event) {
    if (!event.persisted) {
      return;
    }
    this._onCartRefresh();
  }
  /**
   * Listeners called when a new variant has been added
   */
  _onVariantAdded(event) {
    if (
      window.themeVariables.settings.cartType !== "drawer" ||
      event.detail?.blockCartDrawerOpening
    ) {
      return;
    }
    this.show();
  }
  /**
   * Force a complete refresh of the cart drawer (this is called by dispatching the 'cart:refresh' on the document)
   */
  async _onCartRefresh() {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = await (
      await fetch(
        `${window.Shopify.routes.root}?section_id=${extractSectionId(this)}`
      )
    ).text();
    this.replaceChildren(...tempDiv.querySelector("#cart-drawer").children);
  }
};

var CartNotificationDrawer = class extends Drawer {
  constructor() {
    super();
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("variant:add", this._onVariantAddedListener);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("variant:add", this._onVariantAddedListener);
  }
  async show() {
    this.style.display = "block";
    return super.show();
  }
  async hide() {
    super.hide()?.then(() => {
      this.style.display = "none";
    });
  }
  _onVariantAdded(event) {
    if (
      window.themeVariables.settings.cartType !== "popover" ||
      event.detail?.blockCartDrawerOpening
    ) {
      return;
    }
    const tempContent = document.createElement("div");
    tempContent.innerHTML = event.detail.cart["sections"]["variant-added"];
    this.replaceChildren(
      ...tempContent.querySelector(".shopify-section").children
    );
    this.show();
  }
};

var LineItem = class extends HTMLElement {
  connectedCallback() {
    this.pillLoaderElement = this.querySelector("pill-loader");
    this.addEventListener(
      "line-item:will-change",
      this._onWillChange.bind(this)
    );
    this.addEventListener("line-item:change", this._onChanged.bind(this));
  }
  _onWillChange() {
    this.pillLoaderElement.setAttribute("aria-busy", "true");
  }
  async _onChanged(event) {
    this.pillLoaderElement.removeAttribute("aria-busy");
    if (event.detail.cart["item_count"] === 0 || event.detail.quantity !== 0) {
      return;
    }
    console.log(event.detail.cart)
    let marginCompensation = 0;
    if (this.nextElementSibling) {
      marginCompensation = `-${
        getComputedStyle(this.nextElementSibling).paddingTop
      }`;
    }
    await animate4(
      this,
      {
        height: [`${this.clientHeight}px`, 0],
        marginBottom: [0, marginCompensation],
        overflow: "hidden",
        opacity: [1, 0],
      },
      { duration: 0.2, easing: "ease" }
    ).finished;
    this.remove();
    LTKGetCart()
  }
};

if (!window.customElements.get("cart-drawer")) {
  window.customElements.define("cart-drawer", CartDrawer);
}
if (!window.customElements.get("cart-notification-drawer")) {
  window.customElements.define(
    "cart-notification-drawer",
    CartNotificationDrawer
  );
}
if (!window.customElements.get("line-item")) {
  window.customElements.define("line-item", LineItem);
}

// ============================================================
// js/common/cart/cart-note.js
// ============================================================
var CartNote = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this._onNoteChanged);
  }
  _onNoteChanged(event) {
    if (event.target.getAttribute("name") !== "note") {
      return;
    }
    fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: event.target.value }),
      keepalive: true,
    });
  }
};
var CartNoteDialog = class extends DialogElement {
  constructor() {
    super();
    this.addEventListener("change", this._onNoteChanged);
  }
  _onNoteChanged(event) {
    if (event.target.value === "") {
      this.controls.forEach(
        (control) =>
          (control.innerHTML = `<span class="link text-sm text-subdued">${window.themeVariables.strings.addOrderNote}</span>`)
      );
    } else {
      this.controls.forEach(
        (control) =>
          (control.innerHTML = `<span class="link text-sm text-subdued">${window.themeVariables.strings.editOrderNote}</span>`)
      );
    }
  }
};
if (!window.customElements.get("cart-note")) {
  window.customElements.define("cart-note", CartNote);
}
if (!window.customElements.get("cart-note-dialog")) {
  window.customElements.define("cart-note-dialog", CartNoteDialog);
}

// ============================================================
// js/common/cart/free-shipping-bar.js
// ============================================================
var FreeShippingBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["threshold", "total-price"];
  }
  constructor() {
    super();
    this._onCartChangedListener = this._onCartChanged.bind(this);
  }
  async connectedCallback() {
    this.threshold = Math.round(this.threshold * (Shopify.currency.rate || 1));
    document.addEventListener("cart:change", this._onCartChangedListener);
  }
  disconnectedCallback() {
    document.removeEventListener("cart:change", this._onCartChangedListener);
  }
  get threshold() {
    return parseFloat(this.getAttribute("threshold"));
  }
  set threshold(value) {
    this.setAttribute("threshold", value);
  }
  get totalPrice() {
    return parseFloat(this.getAttribute("total-price"));
  }
  set totalPrice(value) {
    this.setAttribute("total-price", value);
  }
  async attributeChangedCallback(attribute, oldValue, newValue) {
    await window.customElements.whenDefined("progress-bar");
    const progressBarElement = this.querySelector("progress-bar");
    switch (attribute) {
      case "threshold":
        progressBarElement.valueMax = newValue;
        break;
      case "total-price":
        progressBarElement.valueNow = newValue;
        break;
    }
    this._updateMessage();
  }
  _updateMessage() {
    const messageElement = this.querySelector("span");
    if (this.totalPrice >= this.threshold) {
      messageElement.innerHTML = this.getAttribute("reached-message");
    } else {
      const replacement = `<span class="text-accent">${formatMoney(
        this.threshold - this.totalPrice
      ).replace(/\$/g, "$$$$")}</span>`;
      messageElement.innerHTML = this.getAttribute("unreached-message").replace(
        new RegExp("({{.*}})", "g"),
        replacement
      );
    }
  }
  _onCartChanged(event) {
    const priceForItems = event.detail["cart"]["items"]
        .filter((item) => item["requires_shipping"])
        .reduce((sum, item) => sum + item["final_line_price"], 0),
      cartDiscount = event.detail["cart"][
        "cart_level_discount_applications"
      ].reduce(
        (sum, discountAllocation) =>
          sum + discountAllocation["total_allocated_amount"],
        0
      );
    this.totalPrice = priceForItems - cartDiscount;
  }
};
if (!window.customElements.get("free-shipping-bar")) {
  window.customElements.define("free-shipping-bar", FreeShippingBar);
}

// ============================================================
// js/common/cart/line-item-quantity.js
// ============================================================
var LineItemQuantity = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this._onQuantityChanged);
    this.addEventListener("click", this._onRemoveLinkClicked);
  }
  _onQuantityChanged(event) {
    if (!event.target.hasAttribute("data-line-key")) {
      return;
    }
    this._changeLineItemQuantity(
      event.target.getAttribute("data-line-key"),
      parseInt(event.target.value),
      event.target.getAttribute("reference"),
    );
  }
  _onRemoveLinkClicked(event) {
    if (
      event.target.tagName !== "A" ||
      !event.target.href.includes("/cart/change")
    ) {
      return;
    }
    event.preventDefault();
    const url = new URL(event.target.href);
    this._changeLineItemQuantity(
      url.searchParams.get("id"),
      parseInt(url.searchParams.get("quantity")),
      url.searchParams.get("reference"),
    );
  }

  async _changeLineItemQuantity(lineKey, targetQuantity, referenceId) {
    console.log("LINE ITEM CHANGED")

    document.querySelectorAll("line-item-quantity button").forEach((btn) => {
      btn.disabled = true
    })

    const lineItem = this.closest("line-item");
    lineItem?.dispatchEvent(
      new CustomEvent("line-item:will-change", {
        bubbles: true,
        detail: { targetQuantity },
      })
    );

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
    const cartContent = await cartResponse.json();

    const findItemsByReferenceId = () => {
      const items = cartContent.items;
      const itemsToChange = items.filter((item) => {
        if (!item.properties || !item.properties['_group_id']) return null;
        return item.properties['_group_id'] == referenceId;
      });
      return itemsToChange;
    };

    let updates = {};

    findItemsByReferenceId().forEach((item) => {
      updates[item.key] = targetQuantity;
    });

    updates[lineKey] = targetQuantity;

    const cartChangeResponse = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: updates,
        sections: sectionsToBundle,
      }),
    });
    const cartContentAfterChange = await cartChangeResponse.json();

    const lineItemAfterChange = cartContentAfterChange.items.filter(
      (lineItem2) => lineItem2.key === lineKey
    );

    lineItem?.dispatchEvent(
      new CustomEvent("line-item:change", {
        bubbles: true,
        detail: {
          quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0].quantity,
          cart: cartContentAfterChange,
        },
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContentAfterChange,
        },
      })
    );

    if (window.themeVariables.settings.pageType === "cart") {
      return (window.location.href = Shopify.routes.root + "cart");
    }

    if (cartChangeResponse.ok) {
      LTKGetCart();
    }

    document.querySelectorAll("line-item-quantity button").forEach((btn) => {
      btn.disabled = false
    });
  }
};
if (!window.customElements.get("line-item-quantity")) {
  window.customElements.define("line-item-quantity", LineItemQuantity);
}

// ============================================================
// js/common/cart/shipping-estimator.js
// ============================================================
var ShippingEstimator = class extends HTMLElement {
  constructor() {
    super();
    this._estimateShippingListener = this._estimateShipping.bind(this);
  }
  connectedCallback() {
    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;
    this.submitButton.addEventListener("click", this._estimateShippingListener);
  }
  disconnectedCallback() {
    this.submitButton.removeEventListener(
      "click",
      this._estimateShippingListener
    );
  }
  /**
   * @doc https://shopify.dev/docs/themes/ajax-api/reference/cart#generate-shipping-rates
   */
  async _estimateShipping(event) {
    event.preventDefault();
    const zip = this.querySelector('[name="address[zip]"]').value,
      country = this.querySelector('[name="address[country]"]').value,
      province = this.querySelector('[name="address[province]"]').value;
    this.submitButton.setAttribute("aria-busy", "true");
    const prepareResponse = await fetch(
      `${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
      { method: "POST" }
    );
    if (prepareResponse.ok) {
      const shippingRates = await this._getAsyncShippingRates(zip, country, province);
      this._formatShippingRates(shippingRates);
    } else {
      const jsonError = await prepareResponse.json();
      this._formatError(jsonError);
    }
    this.resultsElement.hidden = false;
    this.submitButton.removeAttribute("aria-busy");
  }
  async _getAsyncShippingRates(zip, country, province) {
    const response = await fetch(
      `${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
    );
    const responseAsText = await response.text();
    if (responseAsText === null) {
      return this._getAsyncShippingRates(zip, country, province);
    } else {
      return JSON.parse(responseAsText)["shipping_rates"];
    }
  }
  _formatShippingRates(shippingRates) {
    let formattedShippingRates = shippingRates.map(
      (shippingRate) =>
        `<li>${shippingRate["presentment_name"]}: ${shippingRate["currency"]} ${shippingRate["price"]}</li>`
    );
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${
          shippingRates.length === 0
            ? window.themeVariables.strings.shippingEstimatorNoResults
            : shippingRates.length === 1
            ? window.themeVariables.strings.shippingEstimatorOneResult
            : window.themeVariables.strings.shippingEstimatorMultipleResults
        }</p>
        ${formattedShippingRates ? `<ul class="list-disc" role="list">${formattedShippingRates.join("")}</ul>` : ""}
      </div>`;
  }
  _formatError(errors) {
    let formattedShippingRates = Object.keys(errors).map(
      (errorKey) => `<li>${errors[errorKey]}</li>`
    );
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="list-disc" role="list">${formattedShippingRates}</ul>
      </div>`;
  }
};
if (!window.customElements.get("shipping-estimator")) {
  window.customElements.define("shipping-estimator", ShippingEstimator);
}
